/*
  File name: fbner.js
    Program Description:
    - This file uses the baseUrl method and the specified functions inside the
    rest file in order to send requests from the web application to the server.
    - This file is focused on the requests related to the FBNER feature
*/
import { baseUrl } from '@/settings'
import { patch } from '@/utils/rest'

const fbner = {
  endorse: (_id, body) => patch(`${baseUrl}/endorse/${_id}`, body)
}

export default fbner
